import { FlexProps, forwardRef } from '@chakra-ui/react';
import { FC } from 'react';

import { PosterLectureSearchCard } from '@/components/ui/shared/lecture/LectureSearchCard/components/PosterLectureSearchCard';
import { SessionLectureSearchCard } from '@/components/ui/shared/lecture/LectureSearchCard/components/SessionLectureSearchCard';
import { ThinLecture } from '@/resources/ThinLecture';

export interface ILectureSearchCardProps extends FlexProps {
  lecture: ThinLecture;
  eventId: string;
}

export const LectureSearchCard: FC<ILectureSearchCardProps> = forwardRef<ILectureSearchCardProps, 'div'>((props) => {
  const { lecture, eventId } = props;

  const { posterLecture } = lecture;

  return posterLecture ? (
    <PosterLectureSearchCard lecture={lecture} eventId={eventId} />
  ) : (
    <SessionLectureSearchCard lecture={lecture} eventId={eventId} />
  );
});
